import React from 'react'

import EsgEmailAlert from '../EsgEmailAlert'

const EsgDailyEmail = ({ data }) => (
  <EsgEmailAlert data={data} config={{ timeFrameDays: 1 }}/>
)
export default EsgDailyEmail
